import { render } from "./PlanBreakdown.vue?vue&type=template&id=f5ac213a&scoped=true"
import script from "./PlanBreakdown.vue?vue&type=script&lang=js"
export * from "./PlanBreakdown.vue?vue&type=script&lang=js"

import "./PlanBreakdown.vue?vue&type=style&index=0&id=f5ac213a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ac213a"]])

export default __exports__